import { useState } from "react";
import PersonnelInformationFormSupport from "../HRINF/ApplicantInformation/MainPage/PersonnelInformationFormSupport";
import formValidator from "../../utils/validations/formValidatorV2";

const ValidationTests = () => {
  const [
    personnelInformationFormSupportDto,
    personnelInformationFormSupportView,
    personnelInformationFormSupportDtoToView,
    personnelInformationFormSupportViewToDto,
    fieldNameAddresses,
    personnelInformationFromValidity,
  ] = PersonnelInformationFormSupport();
  const fieldAccessesValidations = {
    ECIPersonAddress: [
      {
        fieldName: "ECIPersonAddress_longitude",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "JustNumbers",
        isMandatory: false,
      },
      {
        fieldName: "ECIPersonAddress_latitude",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "JustNumbers",
        isMandatory: false,
      },
      {
        fieldName: "ECIPersonAddress_postalCode",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "PostalCode",
        isMandatory: false,
      },
      //   {
      //     fieldName: "ECIPersonAddress_eci_personAddressContactInfos",
      //     inWhichStateOrderItBecomesNecessary: null,
      //     validationType: null,
      //     isMandatory: true,
      //   },
    ],
    // ECIPersonAddressContactInfo: [
    //   {
    //     fieldName: "ECIPersonAddressContactInfo_value",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustNumbers",
    //     isMandatory: true,
    //   },
    // ],
    // ECIPersonnelInformation: [
    //   {
    //     fieldName: "ECIPersonnelInformation_eci_courses",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: null,
    //     isMandatory: true,
    //   },
    // ],
    // ECICourse: [
    //   {
    //     fieldName: "ECICourse_title",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: null,
    //     isMandatory: true,
    //   },
    //   {
    //     fieldName: "ECICourse_duration",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustNumbers",
    //     isMandatory: false,
    //   },
    // ],
    // ECIRecommender: [
    //   {
    //     fieldName: "ECIRecommender_relation",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustAlphabet",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIRecommender_cellphone",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "Cellphone",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIRecommender_age",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustNumbers",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIRecommender_fullName",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustAlphabet",
    //     isMandatory: true,
    //   },
    // ],
    // ECIEducationalBackground: [
    //   {
    //     fieldName: "ECIEducationalBackground_major",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: null,
    //     isMandatory: true,
    //   },
    //   {
    //     fieldName: "ECIEducationalBackground_gradePointAverage",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustNumbers",
    //     isMandatory: false,
    //   },
    // ],
    // ECIFamilyMember: [
    //   {
    //     fieldName: "ECIFamilyMember_age",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustNumbers",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIFamilyMember_cellphone",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "Cellphone",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIFamilyMember_fullName",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustAlphabet",
    //     isMandatory: true,
    //   },
    // ],
    // ECIPersonContactInfo: [
    //   {
    //     fieldName: "ECIPersonContactInfo_value",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustNumbers",
    //     isMandatory: true,
    //   },
    // ],
    // ECIWorkExperience: [
    //   {
    //     fieldName: "ECIWorkExperience_directManagerCellphone",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "Cellphone",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIWorkExperience_directManagerName",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustAlphabet",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIWorkExperience_salary",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustNumbers",
    //     isMandatory: true,
    //   },
    //   {
    //     fieldName: "ECIWorkExperience_workshopInsuranceCode",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "InsuranceCode",
    //     isMandatory: false,
    //   },
    // ],
    // ECIPerson: [
    //   {
    //     fieldName: "ECIPerson_email",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "Email",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIPerson_fatherName",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustAlphabet",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIPerson_certifSerialNumber",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustNumbers",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIPerson_certifNumber",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustNumbers",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIPerson_lastName",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustAlphabet",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIPerson_cellphone",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "Cellphone",
    //     isMandatory: false,
    //   },
    //   {
    //     fieldName: "ECIPerson_nationalCode",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "NationalCode",
    //     isMandatory: true,
    //   },
    //   {
    //     fieldName: "ECIPerson_genderEnum",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: null,
    //     isMandatory: true,
    //   },
    //   {
    //     fieldName: "ECIPerson_firstName",
    //     inWhichStateOrderItBecomesNecessary: null,
    //     validationType: "JustAlphabet",
    //     isMandatory: false,
    //   },
    // ],
    JobApply: [
      {
        fieldName: "JobApply_businessUnit",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: null,
        isMandatory: true,
      },
      {
        fieldName: "JobApply_pledgeValue",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "JustNumbers",
        isMandatory: false,
      },
      {
        fieldName: "JobApply_pledgorName",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "JustAlphabet",
        isMandatory: true,
      },
      {
        fieldName: "JobApply_salaryExpectation",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "JustNumbers",
        isMandatory: false,
      },
      {
        fieldName: "JobApply_workStartDate",
        inWhichStateOrderItBecomesNecessary: 2,
        validationType: null,
        isMandatory: false,
      },
      {
        fieldName: "JobApply_firstName",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "JustAlphabet",
        isMandatory: false,
      },
      {
        fieldName: "JobApply_corporateChart",
        inWhichStateOrderItBecomesNecessary: 2,
        validationType: null,
        isMandatory: false,
      },
      {
        fieldName: "JobApply_lastName",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "JustAlphabet",
        isMandatory: true,
      },
      {
        fieldName: "JobApply_nationalCode",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "NationalCode",
        isMandatory: true,
      },
      {
        fieldName: "JobApply_cellphone",
        inWhichStateOrderItBecomesNecessary: null,
        validationType: "Cellphone",
        isMandatory: false,
      },
    ],
  };
  const data = {
    id: null,
    firstName: null,
    lastName: "poi",
    nationalCode: "0021192006",
    cellphone: "09120892639",
    workStartDate: "askdhv",
    readyToStartWorkDate: null,
    salaryExpectation: null,
    pledgeValue: "5465",
    pledgeTypeEnum: null,
    pledgorName: "po",
    preferredTimeZone: "+3:30",
    preferredLanguage: "persian",
    preferredCalendar: "pe",
    personnelSalaryDifferenceValue: null,
    personnel_salaryDifferenceToDate: null,
    state: null,
    stateEnglishName: null,
    documentSubmissionSchedules: null,
    startWorkSchedules: null,
    businessUnit: "hi",
    mainOffice: null,
    otherOffices: null,
    mainOrganizationalTitle: null,
    otherInterestedInOrganizationalTitles: null,
    corporateChart: "asvh",
    processVersion: null,
    eci_personnelInformation: {
      id: null,
      insuranceCode: "0022222222",
      jobApply: null,
      insuranceDate: null,
      editingFieldsOfMainObject: null,
      relatedMainObject: null,
      eci_person: {
        id: null,
        fatherName: null,
        certifNumber: null,
        birthplace: null,
        certifSerialNumber: null,
        certifIssuanceDate: null,
        maritalStatusEnum: null,
        militaryStatusEnum: null,
        healthProblems: null,
        hasClassOneDriversLicense: null,
        hasClassTwoDriversLicense: null,
        hasBikeLicense: null,
        birthCertificateIssuingPlace: null,
        bloodTypeEnum: null,
        nationalCode: "0021192006",
        firstName: null,
        lastName: null,
        birthDate: null,
        genderEnum: null,
        cellphone: null,
        email: null,
        nationalityEnum: "ایرانی",
        isActive: null,
        eci_personContactInfos: [
          {
            id: null,
            value: "hvvg",
            contactInfoTypeEnum: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
          {
            id: null,
            value: "56165",
            contactInfoTypeEnum: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ],
        eci_personAddresses: [
          {
            id: null,
            address: null,
            postalCode: null,
            countryEnum: "ایران",
            latitude: null,
            longitude: null,
            addressTypeEnum: null,
            province: null,
            eci_personAddressContactInfos: [
              //   {
              //     id: null,
              //     value: "8888",
              //   },
              //   {
              //     id: null,
              //     value: null,
              //   },
            ],
            city: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
          {
            id: null,
            address: null,
            postalCode: null,
            countryEnum: "ایران",
            latitude: null,
            longitude: null,
            addressTypeEnum: null,
            province: null,
            eci_personAddressContactInfos: [
              {
                id: null,
                value: "6666",
              },
              {
                id: null,
                value: "soli",
              },
            ],
            city: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ],
        personTags: null,
        personTitle: null,
        editingFieldsOfMainObject: null,
        relatedMainObject: null,
      },
      ci_personnel: [
        {
          id: null,
          personnelCode: null,
          internalPhoneNumber: null,
          pledgeValue: null,
          pledgeTypeEnum: null,
          pledgorName: null,
          isActive: true,
          ci_personnelFiles: null,
          ci_personnelContracts: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_educationalBackgrounds: [
        {
          id: null,
          startDate: null,
          finishDate: null,
          thesisAim: null,
          favoriteUnits: null,
          gradePointAverage: null,
          otherInstitute: null,
          degreeLevelEnum: null,
          academicOrientation: null,
          major: null,
          educationalInstitute: { id: null },
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
          currentlyStudying: null,
        },
      ],
      eci_recommenders: [
        {
          id: null,
          fullName: "asdasdasdasd",
          age: null,
          cellphone: null,
          job: null,
          workplace: null,
          relation: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
        {
          id: null,
          fullName: null,
          age: null,
          cellphone: null,
          job: null,
          workplace: null,
          relation: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_personnelInformationFiles: [
        {
          id: null,
          personnelFileTypeEnum: null,
          isActive: null,
          eci_personnelInformation: null,
          fileStorage: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
          tempFileStorage: {
            uploadedFile: null,
            uploadedFileReader: null,
            downloadedFile: null,
            successfullyUploadedFileId: null,
            hasChanged: null,
          },
        },
      ],
      eci_courses: [
        {
          id: null,
          title: null,
          startDate: null,
          duration: null,
          hasDiploma: null,
          otherInstitute: null,
          educationalInstitute: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_familyMembers: [
        {
          id: null,
          fullName: null,
          familyRelationEnum: null,
          age: null,
          job: "ahmad mohsen",
          cellphone: null,
          workplace: null,
          isDead: false,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
        {
          id: null,
          fullName: "hoho",
          familyRelationEnum: "ali karimi eshgh",
          age: null,
          job: "ahmad mohsen",
          cellphone: null,
          workplace: null,
          isDead: false,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
        {
          id: null,
          fullName: null,
          familyRelationEnum: null,
          age: null,
          job: "ahmad mohsen",
          cellphone: null,
          workplace: null,
          isDead: false,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_workExperiences: [
        {
          id: null,
          employer: null,
          post: null,
          directManagerName: null,
          directManagerCellphone: null,
          workshopInsuranceCode: null,
          salary: "asjdbvj",
          resigningReason: null,
          startDate: null,
          finishDate: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
        {
          id: null,
          employer: null,
          post: null,
          directManagerName: null,
          directManagerCellphone: null,
          workshopInsuranceCode: null,
          salary: "15654",
          resigningReason: null,
          startDate: null,
          finishDate: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
        {
          id: null,
          employer: null,
          post: null,
          directManagerName: null,
          directManagerCellphone: null,
          workshopInsuranceCode: null,
          salary: null,
          resigningReason: null,
          startDate: null,
          finishDate: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_policeClearanceCertificates: [
        {
          id: null,
          policeClearanceCertificateDate: null,
          policeClearanceCertificateCode: null,
          fileStorage: null,
          tempFileStorage: {
            uploadedFile: null,
            uploadedFileReader: null,
            downloadedFile: null,
            successfullyUploadedFileId: null,
            hasChanged: null,
          },
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      ci_personnelBankAccounts: [
        {
          id: null,
          bankAccountNumber: null,
          ibanCode: null,
          isActive: true,
          isDefault: null,
          isForThirdParty: false,
          bankAccountOwnerFullName: null,
          relationWithPersonnel: null,
          otherIndividualIntroductionDocument: null,
          tempOtherIndividualIntroductionDocument: {
            uploadedFile: null,
            uploadedFileReader: null,
            downloadedFile: null,
            successfullyUploadedFileId: null,
            hasChanged: null,
          },
          bankBranch: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
    },
  };
  const [formValidity, setFormValidity] = useState(personnelInformationFromValidity);
  const insertLocalValidations = [
    // {
    //   fieldName: "eci_personnelInformation.eci_person.certifSerialNumber",
    //   validityInfos: { type: "definedLength", length: 6 },
    // },
    // { fieldName: "workStartDate", validityInfos: { type: "mandatory" } },
    // { fieldName: "eci_personnelInformation.insuranceCode", validityInfos: { type: "mandatory" } },
    // { fieldName: "eci_personnelInformation.eci_person.genderEnum", validityInfos: { type: "mandatory" } },
    // { fieldName: "eci_personnelInformation.eci_person.firstName", validityInfos: { type: "mandatory" } },
    // { fieldName: "eci_personnelInformation.eci_person.lastName", validityInfos: { type: "mandatory" } },
    // {
    //   fieldName: "eci_personnelInformation.eci_person.nationalCode",
    //   validityInfos: { type: "nationalCode" },
    // },
    // { fieldName: "eci_personnelInformation.eci_person.cellphone", validityInfos: { type: "cellphone" } },
    // {
    //   fieldName: "eci_personnelInformation.eci_person.certifNumber",
    //   validityInfos: { type: "mandatory" },
    // },
    // {
    //   fieldName: "eci_personnelInformation.eci_person.birthCertificateIssuingPlace",
    //   validityInfos: { type: "mandatory" },
    // },
    // { fieldName: "eci_personnelInformation.eci_person.birthplace", validityInfos: { type: "mandatory" } },
    // {
    //   fieldName: "eci_personnelInformation.eci_person.maritalStatusEnum",
    //   validityInfos: { type: "mandatory" },
    // },
    // {
    //   fieldName:
    //     "eci_personnelInformation.eci_person.eci_personAddresses.[].eci_personAddressContactInfos.[].value",
    //   validityInfos: { type: "JustNumbers", isOptional: false },
    // },
    // {
    //   fieldName: "eci_personnelInformation.eci_person.eci_personAddresses.[].eci_personAddressContactInfos",
    //   validityInfos: { type: "mandatory" },
    // },
    // {
    //   fieldName: "eci_personnelInformation.eci_person.eci_personAddresses",
    //   validityInfos: { type: "mandatory" },
    // },
    // { fieldName: "eci_personnelInformation.insuranceDate", validityInfos: { type: "mandatory" } },
    // {
    //   fieldName: "eci_personnelInformation.eci_familyMembers.[].familyRelationEnum",
    //   validityInfos: { type: "mandatory" },
    // },
    // {
    //   fieldName: "eci_personnelInformation.eci_familyMembers",
    //   validityInfos: { type: "mandatory" },
    // },
  ];
  const clickValidateHandler = () => {
    const datasAreValid = formValidator({
      clickedActionOrder: 3,
      data,
      setFormValidity,
      localValidationInformation: insertLocalValidations,
      fieldNameAddresses,
      fieldAccessesValidations,
      forceLtr: true,
    });
    console.log("datasAreValid", datasAreValid);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        direction: "ltr",
      }}
    >
      <p onClick={clickValidateHandler}>Click to validate</p>
      <div
        style={{
          width: "100%",
          height: "100%",
          direction: "ltr",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          //   display: flex,
          //   align-items: center,
          //   justify-content: center,
          //   flex-direction: column,
        }}
      >
        <div style={{ width: "50%", direction: "ltr" }}>
          {" "}
          <pre style={{ width: "50%", direction: "ltr" }}>{JSON.stringify(formValidity, null, 15)}</pre>
        </div>
        <div style={{ width: "50%", direction: "ltr" }}>
          {" "}
          <pre style={{ width: "50%", direction: "ltr" }}>{JSON.stringify(data, null, 15)}</pre>
        </div>
      </div>
    </div>
  );
};

export default ValidationTests;
